export const AirportSearch = {
  top: {
    id: 'div-gpt-ad-1500402020933-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_AirportConditionsSearch_top_728x90',
  },
  topMobile: {
    id: 'div-gpt-ad-1500402128658-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_AirportConditionsSearch_top_320x100',
  },
  bottom: {
    id: 'div-gpt-ad-1500402233688-0',
    sizes: [300, 250],
    adSlot: '/1010197/BS_AirportConditionsSearch_top_300x250',
  },
};
export const AirportCurrentConditions = {
  top: {
    id: 'div-gpt-ad-1500402642937-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_AirportConditions_top_728x90',
  },
  topMobile: {
    id: 'div-gpt-ad-1500402570367-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_AirportConditions_top_320x100',
  },
  mapTop: {
    id: 'div-gpt-ad-1470845383089-0',
    sizes: [300, 250],
    adSlot: '/1010197/BS_AirportConditions_top_300x250',
  },
  mapBottom: {
    id: 'div-gpt-ad-1470845383089-1',
    sizes: [300, 250],
    adSlot: '/1010197/BS_AirportConditions_second_300x250',
  },
};



// WEBPACK FOOTER //
// ./modules/AirportCurrentConditions/components/ads.js